<template>
  <div class="contaier">
    <div class="top-nvb_box">
      <div class="top-nvb">
        <div class="logo-box">
          <img alt="" class="img" src="./assets/img/logo.png" />
        </div>
        <span class="lang" @click="changeLanguage($i18n.locale)">{{
          $t("home.lang")
        }}</span>
      </div>
    </div>
    <div class="top-banner">
      <!-- <img
        alt=""
        src="./assets/img/banner1.jpg"
        class="img lg:aspect-7/3 md:aspect-6/3 sm:aspect-3/3 aspect-4/5" /> -->
      <picture class="picture" style="" data-v-5052e3a5="" data-v-893d3ba0=""
        ><source
          srcset="./assets/img/banner1.jpg"
          media="(min-width: 992px)"
          data-v-893d3ba0="" />
        <source
          srcset="./assets/img/banner2.jpg"
          media="(min-width: 576px)"
          data-v-893d3ba0="" />
        <img src="./assets/img/banner3.jpg" loading="lazy" alt="" data-v-893d3ba0=""
      /></picture>
    </div>
    <!-- <div @click="testFn">test</div> -->
    <form-page ref="formPageRef"></form-page>
    <footer-page></footer-page>
  </div>
</template>

<script>
// import { carouselList, textList, imgsrc } from '@/assets/js/static.js'
import FormPage from "@/components/FormPage.vue";
import FooterPage from "@/components/FooterPage.vue";
export default {
  name: "HomeView",
  components: {
    FormPage,
    FooterPage,
  },
  data() {
    return {
      // imageUrl: require("@/assets/img/list/7.jpg"),
      // imgsrc,
      // carouselList,
      // textList,
      speak: "中文",
    };
  },
  computed: {},
  mounted() {
    //可能是router没准备好，用this.$router.onReady解决
    // this.$router.onReady(() => {
    //   let query = this.$route.query;
    //   console.log("onReady :>>query ", query);
    // });

    console.log("(this.$i18n.locale :>>11 ", this.$i18n.locale);
    console.log("this.$route.query.lang :>> ", this.$route.query);

    if (this.$route?.query?.lang) {
      console.log("存在 :>> ");
      if (this.$route.query.lang === "en") {
        this.$i18n.locale = "en";
        this.$refs.formPageRef.changeLanguage("zh");
        window.sessionStorage.setItem("sessionLang", "en");
      } else {
        this.$i18n.locale = "zh";
        this.$router.push({ path: "/survey", query: { lang: "zh" } }).catch((data) => {
          console.log("data :>>00 ", data);
        });
        window.sessionStorage.setItem("sessionLang", "zh");
      }
    } else {
      let lang = window.sessionStorage.getItem("sessionLang") || "zh";
      console.log("不存在 :>> -sessionStorage", lang);
      if (lang === "zh") {
        console.log("进入11111", lang);
        this.$router.push({ path: "/survey", query: { lang: "zh" } }).catch((data) => {
          console.log("data :>> 1", data);
        });
        this.$i18n.locale = "zh";
      } else {
        console.log("进入22222", lang);
        this.$router.push({ path: "/survey", query: { lang: "en" } }).catch((data) => {
          console.log("data :>>2 ", data);
        });
        this.$i18n.locale = "en";
        this.$refs.formPageRef.changeLanguage("zh");
      }
    }
  },
  methods: {
    changeLanguage(lang) {
      console.log("changelang :>> ", lang);
      let lang_ = lang === "zh" ? "en" : "zh";
      this.$i18n.locale = lang_;
      window.sessionStorage.setItem("sessionLang", lang_);
      this.$refs.formPageRef.changeLanguage(lang);

      if (lang === "zh") {
        this.$router.push({ path: "/survey", query: { lang: "en" } }).catch((data) => {
          console.log("data :>> 3", data);
        });
        // this.$router.push(getLocalePath('/about', 'en'))
      } else {
        this.$router.push({ path: "/survey", query: { lang: "zh" } }).catch((data) => {
          console.log("data :>>4 ", data);
        });
      }
    },
    testFn() {
      console.log("this.$i18n.locale :>> ", this.$i18n.locale);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "element-ui/lib/theme-chalk/display.css";
.img {
  object-fit: cover;
}
.contaier {
  .top-nvb_box {
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    border-bottom: #ccc solid 1px;
    z-index: 1000;
    background-color: #fff;
    .top-nvb {
      position: relative;
      max-width: 1200px;
      margin: 0 auto;
      padding: 20px 0;
      .logo-box {
        max-width: 120px;
        margin: 0 auto;
      }
      .lang {
        position: absolute;
        top: 50%;
        right: 15px;
        transform: translate(0%, -50%);
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
}
.top-banner {
  width: 100%;
  height: 80vh;
  margin-top: 61px;
  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
